import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description House icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { House } from '@sravni/design-system-icons'
 *
 * <House />
 * ```
 */
var House = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "House", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M.714 9.613 9.18 2.448a1.253 1.253 0 0 1 1.64 0l8.466 7.164M12.857 17.143V13.57a2.857 2.857 0 0 0-5.714 0v3.572", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M17.142 7.857v8.572c0 .79-.64 1.428-1.428 1.428H4.285c-.79 0-1.429-.639-1.429-1.428V7.857", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }))); });

export { House };
//# sourceMappingURL=House.js.map
